import React from 'react'
import { Navigate, Outlet, } from 'react-router-dom'
 
export default function publicRoute() {
    const auth = localStorage.getItem('userDetails')
  return (
    !auth ? <Outlet/> : <Navigate to ={"/dashboard"}/>
  )
}